import { forwardRef, HTMLAttributes, memo, MouseEvent,useState } from 'react';
import { SVG } from 'components';
import { message } from 'components/ui';
import { copyToClipboard } from 'components/ui/utils';
import { IconWrapper, Wrapper } from './copy-button.styled';
import { Icons } from 'assets';

export type CopyButtonStatusType = 'idle' | 'copied' | 'error';

type CopyButtonProps = {
  value: string;
  successText?: string;
  errorText?: string;
} & HTMLAttributes<HTMLButtonElement>;

export const CopyButton = memo(
  forwardRef<HTMLButtonElement, CopyButtonProps>(
    ({ value, successText, errorText, ...props }, ref) => {
      const [status, setStatus] = useState<CopyButtonStatusType>('idle');

      const handleCopy = async (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();

        try {
          await copyToClipboard(value, true);
          setStatus('copied');

          if (successText) {
            message({
              text: successText,
              type: 'success',
            });
          }
        } catch (error) {
          setStatus('error');

          if (errorText) {
            message({
              text: errorText,
              type: 'error',
            });
          }
        }

        setTimeout(() => setStatus('idle'), 1500);
      };

      return (
        <Wrapper
          {...props}
          ref={ref}
          onClick={(e) => handleCopy(e)}
          $status={status}
        >
          <IconWrapper>
            <div className={status === 'idle' ? 'fade-in' : 'fade-out'}>
              <SVG src={Icons.Clone} />
            </div>

            <div className={status === 'copied' ? 'fade-in' : 'fade-out'}>
              <SVG src={Icons.Check} />
            </div>

            <div className={status === 'error' ? 'fade-in' : 'fade-out'}>
              <SVG src={Icons.Cross} />
            </div>
          </IconWrapper>
        </Wrapper>
      );
    }
  )
);
